import { BLOCKLISTED_QUERY_PARAMS } from './url/clean-params';

// Bearer secrets live in the path or query. Session Replay stores the URL and
// HTML attributes (including <meta name="react-app-jwt">), so masking input
// values does not hide them. cio_link_id and rc are not credentials.
const SECRET_QUERY_PARAMS = [
  ...BLOCKLISTED_QUERY_PARAMS.filter((param) => param !== 'cio_link_id' && param !== 'rc'),
  'login_token',
  'token',
];

const SECRET_PATH_PATTERNS = [
  /^\/passwords\/[^/?#]+/,
  /^\/login\/[^/?#]+/,
  /^\/organization\/registration\/[^/?#]+/,
  /^\/subscription\/receipts\/[^/?#]+\/[^/?#]+/,
  /^\/admin_list\/unsubscribe\/[^/?#]+/,
];

function pathsToCheck(url) {
  const paths = [url.pathname];

  url.searchParams.forEach((value) => {
    if (!value) return;

    if (value.startsWith('/')) {
      paths.push(value.split('?')[0].split('#')[0]);
      return;
    }

    try {
      paths.push(new URL(value).pathname);
    } catch (e) {
      // Query value is not a URL.
    }
  });

  return paths;
}

export function urlContainsSecret(urlString) {
  if (!urlString) return false;

  let url;
  try {
    url = new URL(urlString, 'https://www.theinformation.com');
  } catch (e) {
    return true;
  }

  const pathIsSecret = pathsToCheck(url).some((path) =>
    SECRET_PATH_PATTERNS.some((pattern) => pattern.test(path))
  );
  if (pathIsSecret) return true;

  return SECRET_QUERY_PARAMS.some((param) => {
    const value = url.searchParams.get(param);
    return value != null && value !== '';
  });
}

export function shouldCaptureMixpanel(locationUrl, referrerUrl) {
  return !urlContainsSecret(locationUrl) && !urlContainsSecret(referrerUrl);
}
